import { createTheme } from '@mui/material/styles';

// Colori estratti dal logo Macrolibrarsi
const macrolibrarsiGreen = '#006633';  // Verde del logo e testo
const macrolibrarsiYellow = '#FFCC00'; // Giallo del cerchio
const errorRed = '#e65c5c';            // Colore di errore fornito
const warningOrange = '#ff6600';       // Colore di avviso fornito

// Creazione del tema personalizzato
const muiTheme = createTheme({
    palette: {
        primary: {
            main: macrolibrarsiGreen,
            light: '#3d8a5f',
            dark: '#004d26',
            contrastText: '#ffffff',
        },
        secondary: {
            main: macrolibrarsiYellow,
            light: '#ffdc4c',
            dark: '#cc9d00',
            contrastText: '#000000',
        },
        error: {
            main: errorRed,
            light: '#eb7f7f',
            dark: '#c23d3d',
            contrastText: '#ffffff',
        },
        warning: {
            main: warningOrange,
            light: '#ff8533',
            dark: '#cc5200',
            contrastText: '#ffffff',
        },
        info: {
            main: '#4dabf5',
            light: '#6fbaf7',
            dark: '#3b8bc2',
            contrastText: '#ffffff',
        },
        success: {
            main: '#4caf50',
            light: '#6fbf73',
            dark: '#3b873d',
            contrastText: '#ffffff',
        },
        background: {
            default: '#f9f9f5',
            paper: '#ffffff',
        },
        text: {
            primary: '#333333',
            secondary: '#666666',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 500,
            color: macrolibrarsiGreen,
        },
        h2: {
            fontWeight: 500,
            color: macrolibrarsiGreen,
        },
        h3: {
            fontWeight: 500,
            color: macrolibrarsiGreen,
        },
        button: {
            textTransform: 'none',
            fontWeight: 500,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
                containedPrimary: {
                    '&:hover': {
                        backgroundColor: '#004d26',
                    },
                },
                containedSecondary: {
                    '&:hover': {
                        backgroundColor: '#cc9d00',
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.08)',
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
});

export default muiTheme;